// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 999999;
  visibility: visible;
  opacity: 1;
  transition: visibility 0.5s, opacity 0.3s linear;
}
#app-spinner.hide {
  visibility: hidden;
  opacity: 0;
}
#app-spinner h4 {
  margin-top: 10px;
  letter-spacing: 0.02em;
  opacity: 0;
  text-transform: uppercase;
  animation: loading-text-opacity 2s linear 0s infinite normal;
}
#app-spinner img.animated-logo {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes loading-text-opacity {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAGA;EAKI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EAGA,gDAAA;AAFJ;AAGI;EACI,kBAAA;EACA,UAAA;AADR;AAGI;EACI,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,yBAAA;EAIA,4DAAA;AADR;AAGI;EAII,sCAAA;AADR;;AAMA;EACI;IAAO,yBAAA;EAFT;AACF;AAcA;EACI;IAAK,UAAA;EAIP;EAHE;IAAK,UAAA;EAMP;EALE;IAAK,UAAA;EAQP;EAPE;IAAK,UAAA;EAUP;AACF","sourcesContent":["// ==========================================================================\r\n// Component: App.component\r\n// ==========================================================================\r\n#app-spinner{\r\n    display: -webkit-box;\r\n    display: -moz-box;\r\n    display: -ms-flexbox;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: fixed;\r\n    top: 0;\r\n    background: #fff;\r\n    z-index: 999999;\r\n    visibility: visible;\r\n    opacity: 1;\r\n    -webkit-transition: visibility 0.5s, opacity 0.3s linear;\r\n    -moz-transition: visibility 0.5s, opacity 0.3s linear;\r\n    transition: visibility 0.5s, opacity 0.3s linear;\r\n    &.hide{\r\n        visibility: hidden;\r\n        opacity: 0; \r\n    }\r\n    h4{\r\n        margin-top: 10px;\r\n        letter-spacing: 0.02em;\r\n        opacity: 0;\r\n        text-transform: uppercase;\r\n        -moz-animation: loading-text-opacity 2s linear 0s infinite normal;\r\n        -o-animation: loading-text-opacity 2s linear 0s infinite normal;\r\n        -webkit-animation: loading-text-opacity 2s linear 0s infinite normal;\r\n        animation: loading-text-opacity 2s linear 0s infinite normal;\r\n    }\r\n    img.animated-logo {\r\n        -moz-animation: rotation 2s infinite linear;\r\n        -o-animation: rotation 2s infinite linear;\r\n        -webkit-animation: rotation 2s infinite linear;\r\n        animation: rotation 2s infinite linear;\r\n    }\r\n}\r\n\r\n\r\n@keyframes rotation { \r\n    100% { transform: rotate(360deg); } \r\n}\r\n@-moz-keyframes rotation { \r\n    100% { -moz-transform: rotate(360deg); } \r\n}\r\n@-webkit-keyframes rotation { \r\n    100% { -webkit-transform: rotate(360deg); } \r\n}\r\n@-o-keyframes rotation { \r\n    100% { -o-transform: rotate(360deg); }\r\n}\r\n\r\n\r\n@keyframes loading-text-opacity {\r\n    0%  {opacity: 0}\r\n    20% {opacity: 0}\r\n    50% {opacity: 1}\r\n    100%{opacity: 0}\r\n}\r\n@-moz-keyframes loading-text-opacity {\r\n    0%  {opacity: 0}\r\n    20% {opacity: 0}\r\n    50% {opacity: 1}\r\n    100%{opacity: 0}\r\n}\r\n@-webkit-keyframes loading-text-opacity {\r\n    0%  {opacity: 0}\r\n    20% {opacity: 0}\r\n    50% {opacity: 1}\r\n    100%{opacity: 0}\r\n}\r\n@-o-keyframes loading-text-opacity {\r\n    0%  {opacity: 0}\r\n    20% {opacity: 0}\r\n    50% {opacity: 1}\r\n    100%{opacity: 0}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
